export const priceFormatter = (amount: number) =>
  `$${(Math.round(amount * 100) / 100).toFixed(2)}`;

export const prettifyTime = (date: Date) =>
  date.toLocaleString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
